import React from 'react';
import { Formik, Form, Field } from 'formik';

import styles from './userSiteNotificationsPageStyles';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import SingleCheckboxField from 'buyside/components/presentation/Form/Field/SingleCheckboxField/singleCheckboxField';
const { whitePaperProductName } = require('buyside/util/constantsFromRails.json');

const getNotificationItems = ({
  includeIdeaWrites,
  includeCapIntro,
  includeComments,
  includeJobPostings,
  includeViewerIntroRequests
}) => {
  return [
    {
      name: 'showContests',
      formInputTitle: 'Contest Notifications',
      formInputDetailText: 'When a new contest starts or you place in a contest'
    },
    {
      name: 'showWatchlist',
      formInputTitle: 'Watchlist Related Activity',
      formInputDetailText: 'Someone tags an entity you follow, watchlist ticker updates'
    },
    {
      name: 'showFollowers',
      formInputTitle: 'New Followers',
      formInputDetailText: 'When you have a new follower'
    },
    {
      name: 'showFolloweeActivity',
      formInputTitle: 'Followee Activity',
      formInputDetailText: 'When a followee publishes or updates their idea'
    },
    {
      name: 'showTrendingResearch',
      formInputTitle: 'Trending Research',
      formInputDetailText: 'When a security/user you follow has made the trending research list'
    },
    {
      name: 'showActivelyDiscussed',
      formInputTitle: 'Actively Discussed Research',
      formInputDetailText: 'When a security/user you follow has made the actively discussed list'
    },
    {
      name: 'showBiggestMovers',
      formInputTitle: 'Biggest Movers',
      formInputDetailText: 'When a security/user you follow has made the biggest movers list'
    },
    {
      name: 'showWhitePapers',
      formInputTitle: 'Macro Thematic',
      formInputDetailText: `When a ${whitePaperProductName} is published that is related to your followed members, funds, sectors or regions`
    },
    includeViewerIntroRequests && {
      name: 'showViewerIntroRequests',
      formInputTitle: 'Report Discussion Requests',
      formInputDetailText:
        'When further discussion about a specific report is requested, either by you or another.'
    },
    includeIdeaWrites && {
      name: 'showIdeas',
      formInputTitle: 'Your Published Ideas',
      formInputDetailText:
        'When you receive an update request, new idea views, an idea rating, or your idea is auto-closed'
    },
    includeIdeaWrites && {
      name: 'showRankings',
      formInputTitle: 'Your Rankings',
      formInputDetailText: 'When your rankings are updated'
    },
    includeIdeaWrites && {
      name: 'showBadges',
      formInputTitle: 'New Badges',
      formInputDetailText: 'When you earn a new badge'
    },
    includeCapIntro && {
      name: 'showNewRecommended',
      formInputTitle: 'New Recommendations',
      formInputDetailText: 'When you receive a new fund/allocator recommendation'
    },
    includeCapIntro && {
      name: 'showCapIntro',
      formInputTitle: 'Cap Intro Notifications',
      formInputDetailText: 'When your fund receives an intro request'
    },
    includeCapIntro && {
      name: 'showFundFollower',
      formInputTitle: 'New Follower of Your Fund',
      formInputDetailText: 'When your fund has a new follower'
    },
    includeComments && {
      name: 'showComments',
      formInputTitle: 'New Comments',
      formInputDetailText: `When someone comments on your idea, post or ${whitePaperProductName}.`
    },
    includeJobPostings && {
      name: 'showJobVault',
      formInputTitle: 'Job Vault',
      formInputDetailText: 'When a new job has been posted'
    }
  ].filter(e => Boolean(e));
};

const SiteNotificationSettings = ({
  handleUpdateSiteNotificationSettings,
  currentUser,
  initialValues
}) => {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, { setSubmitting }) =>
        handleUpdateSiteNotificationSettings(values, setSubmitting)
      }
    >
      {({ values, isSubmitting }) => (
        <Form>
          <div className={styles.categoryContainer}>
            <Field
              component={SingleCheckboxField}
              disabled={isSubmitting}
              label="Show All Notifications"
              name="showAll"
              overrideStyles={styles}
              type="checkbox"
              value={values.showAll}
            />
            <div className={styles.individualField}>
              {getNotificationItems({
                includeIdeaWrites: currentUser.canWriteIdeas,
                includeCapIntro: currentUser.canViewCapIntro,
                includeComments: currentUser.canAccessComments,
                includeJobPostings: currentUser.canAccessJobPostings,
                includeViewerIntroRequests: currentUser.canReceiveViewerIntroRequest
              }).map((data, idx) => (
                <div key={idx}>
                  <Field
                    component={SingleCheckboxField}
                    customStyles={styles}
                    disabled={values.showAll || isSubmitting}
                    label={data.formInputTitle}
                    name={data.name}
                    type="checkbox"
                    value={values[data.name] || values.showAll}
                  />
                  <div className={styles.detailText}>{data.formInputDetailText}</div>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.buttonContainer}>
            <Button
              text={isSubmitting ? 'Submitting' : 'Update Notification Preferences'}
              type={BUTTON_TYPES.PRIMARY}
              isLoading={isSubmitting}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default SiteNotificationSettings;
